import * as React from "react";

import { BlockProps } from "baseui/block";
import { GraphQLTypes } from "kw/api/zeus";
import { StringDisplay } from "./StringDisplay";
import { useFormatter } from "../useFormatter";

export type TRadioButtonDisplay = {
  question?: {
    inputArgs?: {
      options: GraphQLTypes["JSONString"];
    };
  };
  options?: TRadioOptions[];
  answer: string;
} & BlockProps;

export const RadioButtonDisplay: React.FC<TRadioButtonDisplay> = (
  props: TRadioButtonDisplay
) => {
  const { question, answer, options, ...restProps } = props;
  const possibleOptions = options || question?.inputArgs?.options;
  const { formatRadioValue } = useFormatter();
  const stringAnswer = formatRadioValue(answer, possibleOptions);
  return <StringDisplay answer={stringAnswer} {...restProps} />;
};
